<template>
    <div class="form-bootstrap-check form-bootstrap-switch">
        <input class="form-bootstrap-check-input" type="checkbox" role="switch" :id="id" :checked="modelValue"
            :disabled="disabled" @change="onChange" />
    </div>
</template>
<script charset="utf-8">
export default {
    name: "InputSwitch",
    emits: ['update:modelValue', 'change'],
    props: {
        modelValue: {
            type: Boolean,
            required: true,
        },
        id: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        onChange(event) {
            const checked = event.target.checked;
            this.$emit('update:modelValue', checked);
            this.$emit('change', checked);
        },
    },
}
</script>
